import FollowUpModal from "./FollowUpModal";

export default FollowUpModal;
